import { MouseEvent, useCallback, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { IconButton, makeStyles, Menu, MenuItem } from '@material-ui/core'
import { AccountCircle } from '@material-ui/icons'

const useStyles = makeStyles({
  icon: {
    color: 'white',
  },
})

export default function UserMenu() {
  const classes = useStyles()
  const { logout } = useAuth0()
  const [menuAnchorElement, setMenuAnchorElement] =
    useState<null | HTMLElement>(null)

  const openMenu = (event: MouseEvent<HTMLElement>) =>
    setMenuAnchorElement(event.currentTarget)
  const closeMenu = () => setMenuAnchorElement(null)
  const logoutUser = useCallback(() => {
    logout({ returnTo: window.location.origin + process.env.PUBLIC_URL })
  }, [logout])

  return (
    <>
      <IconButton size='medium' className={classes.icon} onClick={openMenu}>
        <AccountCircle />
      </IconButton>
      <Menu
        anchorEl={menuAnchorElement}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(menuAnchorElement)}
        onClose={closeMenu}
      >
        <MenuItem onClick={logoutUser}>Log out</MenuItem>
      </Menu>
    </>
  )
}
